/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RecruitCandidate { 
    id?: string;
    first_name?: string;
    middle_name?: string;
    last_name?: string;
    birthday?: Date;
    gender?: boolean;
    cell_phone?: string;
    private_email?: string;
    address?: string;
    source_category_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    id_card?: string;
    code?: string;
    note?: string;
    image?: string;
}